import { format } from 'date-fns'
import DodoneEditModal from 'app/dodones/edit/Modal'
import DodoneStatsBase from 'app/dodones/shared/Stats/Base'

const formatDateTime = (date) => {
  return format(date, 'HH:mm')
}

export default ({ dodone }) => {
  const getDuration = useCallback(() => {
    const totalSeconds = Math.floor(
      (dodone.finishedAt - dodone.startedAt) / 1000
    )

    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)

    if (hours > 0) {
      return `${hours}h${minutes}m`
    }

    return `${minutes}m`
  })

  return (
    <>
      <DodoneEditModal
        className="dodone-stats mb-d"
        attributesNames={['started_at', 'finished_at']}
      >
        <div className="dodone-stats-timeline">
          <div className="timeline-item">
            {formatDateTime(dodone.startedAt)}
          </div>
          <i className="ph ph-arrow-right" />
          <div className="timeline-item">
            {formatDateTime(dodone.finishedAt)}
          </div>
        </div>
        <div className="dodone-stats-duration">
          <DodoneStatsBase dodone={dodone} />
          {getDuration()}
        </div>
      </DodoneEditModal>
    </>
  )
}
